// @flow
import React from "react";

import SelecaoRadioBaseComTraducao from "../../../comum/SelecaoRadioBaseComTraducao";
import {
  selecionarCapitalutilizado,
  getCapitalUtilizadoSelecionado,
  getCapitaisUtilizados,
} from "../../../../state";

export default function SelecaoCapitalUtilizado() {
  return (
    <div className="ConfiguracaoMedida">
      <SelecaoRadioBaseComTraducao
        chaveTraducaoNomeSelecao={"ConfiguracaoIndicador.capitalUtilizado"}
        itensSelector={getCapitaisUtilizados}
        selectorItemSelecionado={getCapitalUtilizadoSelecionado}
        onItemChange={selecionarCapitalutilizado}
        campoId="codigo"
        campoChaveTraducao="descricao"
      />
    </div>
  );
}
